import PageHead from "@/components/common/PageHead";
import Container from "@airdrop/components/Container";
import { useState, useEffect, useCallback } from "react";
import { ShareIcon } from "@/components/common/icons";
import ShareLinkModal from "@/components/common/ShareLinkModal";

import ZksyncClaimer from "@/components/mint/claimer/Zksync";
import CustomChain from "@/components/mint/claimer/CustomChain";
import { ZetaChain_Test } from "@/chain-info/ZetaChain";
import { Tabs } from "@mantine/core";
import { zksyncChainId } from "@/config/config";
import store, { actions, useTypedSelector } from "@/stores";

const ClaimerMint = () => {
  const [shareLinkOpened, setShareLinkOpened] = useState(false);
  const [shareLink, setShareLink] = useState("");

  const activeChain = useTypedSelector((state) => {
    return state.account.dataChainId;
  });

  const setActiveChain = useCallback((chainId: string) => {
    store.dispatch(actions.account.setDataChainId(parseInt(chainId)));
  }, []);

  useEffect(() => {
    setShareLink(window.location.href);
  }, []);

  return (
    <Container>
      <PageHead></PageHead>
      <div className="layout-block px-5 py-10 pb-[115px] sm:px-[140px] sm:py-[115px]">
        <div className="flex items-center justify-between w-full">
          <div className="max-w-[447px]">
            <div className="text-[28px] leading-tight font-bold text-dark1">
              Claim your Karat ID
            </div>
            <div className="mt-2 font-medium text-dark2">
              Karat ID is a key part of Karat's Multichain Socialfi Dapps and
              Karat’s AA wallet. Karat ID will be the foundation of an
              aggregated multi-chain name service.
            </div>
          </div>
          <div className="flex items-center relative">
            <div
              className="w-[44px] sm:w-[149px] h-[44px] flex items-center justify-center border border-primary text-primary font-semibold rounded-full action"
              onClick={() => {
                setShareLinkOpened(true);
              }}
            >
              <ShareIcon></ShareIcon>
              <span className="ml-1 hidden sm:block">Share</span>
            </div>
            <div className="absolute w-[250px] right-0 sm:left-0 top-[54px]">
              <ShareLinkModal
                opened={shareLinkOpened}
                setOpened={setShareLinkOpened}
                link={shareLink}
              ></ShareLinkModal>
            </div>
          </div>
        </div>
        <div className="flex flex-col flex-col-reverse  sm:flex-row mt-12">
          <div className="sm:mr-14 flex-1">
            <Tabs
              value={String(activeChain)}
              onTabChange={setActiveChain}
              classNames={{
                tabsList: "mb-7",
              }}
            >
              <Tabs.List grow>
                <Tabs.Tab value={String(ZetaChain_Test.chainId)}>
                  ZETA network
                </Tabs.Tab>
                <Tabs.Tab value={String(zksyncChainId)}>
                  zkSync ETH network
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value={String(zksyncChainId)}>
                <ZksyncClaimer></ZksyncClaimer>
              </Tabs.Panel>
              <Tabs.Panel value={String(ZetaChain_Test.chainId)}>
                <CustomChain chainId={ZetaChain_Test.chainId}></CustomChain>
              </Tabs.Panel>
            </Tabs>
          </div>
          <div className="w-full mb-8 sm:mb-0 sm:w-[341px]">
            <img
              src="/assets/mint/claimer-mint-gift.png"
              className="w-full"
            ></img>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ClaimerMint;
